export default __webpack_public_path__ + "static/rsz_1mateusz_cybula-0b4e5e75dde120ff68a4bf6dc1ec4b9d.jpg";